import React from "react";
import ReactDOM from "react-dom/client";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import TataReport from "../tataReport/tatareport";

const loadImages = (container) => {
  return new Promise((resolve) => {
    const imgs = container.getElementsByTagName("img");
    if (imgs.length === 0) return resolve();
    let loaded = 0;
    for (let img of imgs) {
      if (img.complete) {
        loaded++;
        if (loaded === imgs.length) resolve();
      } else {
        img.onload = img.onerror = () => {
          loaded++;
          if (loaded === imgs.length) resolve();
        };
      }
    }
  });
};

const tataVoucherPrint = async (
  clinic,
  qrCodeUrl,
  item,
  referrer,
  extras = {}
) => {
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.top = "-9999px";
  container.style.left = "-9999px";
  container.style.width = "794px";
  container.style.padding = "0";
  document.body.appendChild(container);

  // Build the item data with appointment details included
  const itemData = {
    ...item,
    ...(item?.invoiceId?.[0]?.appointmentDetails || {}),
    patientName: item?.patientId?.userId?.name,
    age: item?.patientId?.userId?.age,
    gender: item?.patientId?.userId?.gender,
    patientId: item?.patientId,
    createdDt: item?.createdDt,
    updatedDt: item?.updatedDt,
  };

  const root = ReactDOM.createRoot(container);
  root.render(
    <TataReport
      clinic={clinic}
      qrCode={qrCodeUrl}
      selectedItem={item}
      item={itemData}
      address={extras.address}
      referrer={referrer}
      watermark={extras.watermark}
      isoLogo={extras.isoLogo}
      footer={extras.footer}
      servicePaymentDetails={itemData?.servicePaymentDetails ?? []}
      forPrint={true}
      reportType={extras.reportType || "referral"}
    />
  );

  const inlineImages = async (rootEl) => {
    const imgs = Array.from(rootEl.getElementsByTagName("img"));
    for (const img of imgs) {
      const src = img.src;
      if (!src) continue;
      try {
        img.crossOrigin = img.crossOrigin || "anonymous";
      } catch (e) {}
      if (
        src.startsWith("data:") ||
        src.startsWith("blob:") ||
        src.startsWith(window.location.origin) ||
        src.startsWith("/")
      )
        continue;
      try {
        const res = await fetch(src, { mode: "cors" });
        if (!res.ok) throw new Error();
        const blob = await res.blob();
        const reader = new FileReader();
        const dataUrl = await new Promise((resolve, reject) => {
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
        img.src = dataUrl;
      } catch (e) {}
    }
  };

  await inlineImages(container);
  await loadImages(container);
  await new Promise((r) => setTimeout(r, 800));
  const finalImgs = container.getElementsByTagName("img");
  const failed = Array.from(finalImgs).filter((i) => i.naturalWidth === 0);
  if (failed.length) {
    console.warn(
      "tataVoucherPrint: some images failed to load for PDF:",
      failed.map((i) => i.src)
    );
  }
  const canvas = await html2canvas(container, {
    scale: 2,
    useCORS: true,
  });

  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  pdf.save("TataReport.pdf");

  root.unmount();
  document.body.removeChild(container);
};

export default tataVoucherPrint;
